var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document-type-chip",class:{ 
    'disabled-chip': _vm.disabled,
    'generating': _vm.isGenerating,
    'premium-chip': _vm.isPremium,
    'upload-chip': _vm.isUpload
  },on:{"click":_vm.handleGenerate}},[_c('div',{staticClass:"chip-content"},[(_vm.isUpload && !_vm.isGenerating)?_c('i',{staticClass:"fas fa-plus upload-icon"}):_vm._e(),_c('span',{staticClass:"chip-title"},[_vm._v(_vm._s(_vm.title))]),(_vm.isGenerating)?_c('b-spinner',{staticClass:"generating-spinner",attrs:{"small":""}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }